module.exports = __webpack_public_path__ + "static/media/torno3.c792b9fd.png";